import type { i18n as i18nInstance } from "i18next";
import { DatesProvider } from "@mantine/dates";
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import "dayjs/locale/fr";

import { enUS, frFR } from "./i18n";
import { useLayoutEffect } from "react";
import { useTranslation } from "react-i18next";
import { ProductTranslationProvider } from "@jasper/translations";

dayjs.extend(customParseFormat);

interface Props {
  children: React.ReactNode;
  i18n: i18nInstance;
}

const FormProvider = ({ children, i18n }: Props) => {
  const { i18n: currentI18n } = useTranslation(undefined, { i18n });
  const datesLocale = currentI18n.language.split("-")[0];

  useLayoutEffect(() => {
    if (!i18n.hasResourceBundle("en-US", "forms")) {
      i18n.addResourceBundle("en-US", "forms", enUS);
    }
    if (!i18n.hasResourceBundle("fr-FR", "forms")) {
      i18n.addResourceBundle("fr-FR", "forms", frFR);
    }
  }, [i18n]);

  return (
    <ProductTranslationProvider i18n={i18n}>
      <DatesProvider settings={{ locale: datesLocale }}>
        {children}
      </DatesProvider>
    </ProductTranslationProvider>
  );
};

export default FormProvider;
